import { toast } from "react-toastify";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import React from "react";

export const showSuccessToast = (message) => {
  toast.success(
    <div className="toast-body">
      <FaCheckCircle
        className="toast-icon"
        style={{ color: "rgba(77, 100, 102, 1)" }}
      />
      <span>{message}</span>
    </div>
  );
};

export const showErrorToast = (message) => {
  toast.error(
    <div className="toast-body">
      <FaTimesCircle
        className="toast-icon"
        style={{ color: "rgba(239, 67, 70, 1)" }}
      />
      <span>{message}</span>
    </div>
  );
};
